/* HMX V50 — wallet-exact after-scroll repair for legacy sticky carts.
   Only activates when Shopify's native sticky-atc was rendered as always-visible.
   Never reads, writes, or dispatches events on the main product form. */
(function () {
  'use strict';

  var ROOT = 'sticky-atc.sticky-atc:not(.hmx-universal-sticky-atc)';
  var MARKER = 'hmxWalletAfterScrollV50';

  function floatingButtons(passed, height) {
    Array.prototype.forEach.call(document.querySelectorAll('.floating-btn'), function (button) {
      button.style.setProperty('--sticky-atc-offset', passed ? height + 'px' : '0px');
    });
  }

  function setup(root) {
    if (!root || !root.isConnected || root.dataset[MARKER] === 'true') return;

    // Wallet templates already have Shopify's native after-scroll listener.
    if (root.dataset.isAfterScroll === 'true' || root.isAfterScroll === true) {
      root.dataset[MARKER] = 'native';
      return;
    }

    var sectionId = root.dataset.section;
    var mainAtcButton = sectionId
      ? document.querySelector('#ProductSubmitButton-' + sectionId)
      : null;

    if (!mainAtcButton) return;

    root.dataset[MARKER] = 'true';
    root.dataset.isAfterScroll = 'true';

    function syncWalletVisibility() {
      if (!root.isConnected || !mainAtcButton.isConnected) return;

      // This is Shopify's native wallet trigger, copied exactly.
      var passed = window.scrollY > mainAtcButton.offsetTop + mainAtcButton.offsetHeight;
      root.style.transform = passed ? 'none' : '';
      root.scrolledPast = passed;
      floatingButtons(passed, root.offsetHeight);
    }

    syncWalletVisibility();
    document.addEventListener('scroll', syncWalletVisibility, { passive: true });
    window.addEventListener('resize', syncWalletVisibility, { passive: true });
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches(ROOT)) setup(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT), setup);
  }

  function start() {
    scan(document);
    window.setTimeout(function () { scan(document); }, 100);
    window.setTimeout(function () { scan(document); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
